/* ============================================================
   FRAISE NOIRE — Favoris persistants
   localStorage 'fn_wish_v1' (liste de handles). S'appuie sur le
   toggle visuel déjà géré par home.js (.card__wish is-on) : ici on
   persiste, on marque les cartes rendues, on gère le badge et le
   panneau Favoris (cœur de la nav).
   Chargé APRÈS home.js.
   ============================================================ */
(() => {
  /* Echappement — voir js/home.js. Les titres du catalogue contiennent des
     guillemets droits qui, non echappes, ferment l'attribut qui les porte. */
  const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ESCAPES[c]);

  'use strict';
  const P = window.FN_PRODUCTS || [];
  const KEY = 'fn_wish_v1';
  const eur = n => n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  let wish = [];
  try { const s = JSON.parse(localStorage.getItem(KEY)); if (Array.isArray(s)) wish = s; } catch (_) {}
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(wish)); } catch (_) {} };
  const find = h => P.find(p => p.handle === h);
  const handleOf = card => {
    const a = card && card.querySelector('.card__link');
    if (!a) return null;
    return new URLSearchParams((a.getAttribute('href') || '').split('?')[1] || '').get('handle');
  };

  /* ---- badge sur le cœur de la nav ---- */
  const navHeart = document.querySelector('.icon-btn[aria-label="Favoris"]');
  let badge = null;
  if (navHeart) {
    badge = document.createElement('span');
    badge.className = 'icon-btn__badge';
    badge.hidden = true;
    navHeart.style.position = 'relative';
    navHeart.appendChild(badge);
  }
  function renderBadge() {
    if (!badge) return;
    badge.textContent = wish.length;
    badge.hidden = wish.length === 0;
  }

  /* ---- marquer les cœurs des cartes déjà rendues (et re-rendues) ---- */
  function markCards(root) {
    (root || document).querySelectorAll('.card').forEach(card => {
      const h = handleOf(card);
      const btn = card.querySelector('.card__wish');
      if (!h || !btn) return;
      const on = wish.includes(h);
      btn.classList.toggle('is-on', on);
      btn.style.color = on ? 'var(--fraise)' : '';
    });
  }
  markCards();
  new MutationObserver(muts => {
    for (const m of muts) for (const n of m.addedNodes)
      if (n.nodeType === 1 && (n.matches?.('.card') || n.querySelector?.('.card'))) { markCards(n.parentNode || n); return; }
  }).observe(document.body, { childList: true, subtree: true });

  /* ---- persistance du toggle (le visuel est fait par home.js) ---- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.card__wish');
    if (btn) {
      const h = handleOf(btn.closest('.card'));
      if (!h) return;
      const on = btn.classList.contains('is-on'); // état APRÈS le toggle de home.js
      if (on && !wish.includes(h)) wish.push(h);
      if (!on) wish = wish.filter(x => x !== h);
      save(); renderBadge();
      if (panel && !panel.hidden) renderPanel();
      return;
    }
    if (e.target.closest('.icon-btn[aria-label="Favoris"]')) { openPanel(); return; }
    if (e.target.closest('[data-wish-rm]')) {
      const h = e.target.closest('[data-wish-rm]').dataset.wishRm;
      wish = wish.filter(x => x !== h);
      save(); renderBadge(); renderPanel(); markCards();
      return;
    }
    if (panel && !panel.hidden && (e.target === panel || e.target.closest('[data-wish-close]'))) closePanel();
  });

  /* ---- panneau Favoris ---- */
  let panel = null;
  function buildPanel() {
    panel = document.createElement('div');
    panel.className = 'fwish';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Favoris');
    panel.hidden = true;
    document.body.appendChild(panel);
  }
  function renderPanel() {
    const items = wish.map(find).filter(Boolean);
    panel.innerHTML = `
      <div class="fwish__panel">
        <header class="fwish__head"><h3>Favoris <span>(${items.length})</span></h3>
          <button class="icon-btn" aria-label="Fermer" data-wish-close><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7"><path d="m6 6 12 12M18 6 6 18"/></svg></button>
        </header>
        ${items.length ? `<div class="fwish__list">` + items.map(p => `
          <div class="fwish__item">
            <a href="${p.url || "/products/" + p.handle}">${(window.FN && window.FN.media) ? window.FN.media(p.img, 'alt="" loading="lazy"', '64px') : `<img src="${p.img}" alt="">`}</a>
            <div><a class="fwish__name" href="${p.url || "/products/" + p.handle}">${esc(p.title)}</a>
              <span class="fwish__cat label">${esc(p.cat)}</span>
              <button class="fwish__rm" data-wish-rm="${esc(p.handle)}">Retirer</button></div>
            <b class="tabular">${eur(p.price)}</b>
          </div>`).join('') + `</div>`
        : `<p class="fwish__empty">Aucun favori pour l'instant.<br>Touche le cœur d'une pièce pour la garder ici.</p>
           <a class="btn btn--solid" href="/collections/all">Découvrir la collection</a>`}
      </div>`;
  }
  function openPanel() { if (!panel) buildPanel(); renderPanel(); panel.hidden = false; requestAnimationFrame(() => panel.classList.add('show')); }
  function closePanel() { panel.classList.remove('show'); setTimeout(() => { panel.hidden = true; }, 220); }
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && panel && !panel.hidden) closePanel(); });

  renderBadge();
})();
